export const GET_HOME_CONTENT = 'GET_HOME_CONTENT';
export const GET_CATEGORY_CLIENTCONTENT = 'GET_CATEGORY_CLIENTCONTENT';
export const UNAUTH_USER = 'unauth_user';
